import { removeWhitespace } from './utils';

export default (phoneNumberString?: { value: string } | string | undefined) => {
    const mappedPhoneNumber = typeof phoneNumberString === 'object' ? phoneNumberString.value : phoneNumberString ?? '';
    if (!mappedPhoneNumber) return '';
    const phoneNumber = removeWhitespace(mappedPhoneNumber);
    if (phoneNumber.length === 8 || (phoneNumber.length === 11 && phoneNumber.startsWith('+'))) {
        const match = phoneNumber.match(/(\+\d{2})?(\d{3})(\d{2})(\d{3})/);
        return match && match.length === 5
            ? `${match[1] ? `${match[1]} ` : ''}${match[2]} ${match[3]} ${match[4]}`
            : phoneNumber;
    }
    return phoneNumber;
};
